/** Print-safe proposal PDF typography tokens (BOM-aligned, high contrast). */
export const PDF_TEXT = "#1A2744";
export const PDF_TEXT_MUTED = "#4B5563";
export const PDF_TEXT_SUBTLE = "#374151";
export const PDF_ACCENT = "#C8A96A";
export const PDF_BG_TINT = "#FAFAF7";

/** Body copy in PDF mode — ~10–15% smaller than screen defaults. */
export const PDF_BODY_CLASS = "text-[11px] leading-[1.45] text-[#374151]";

/** Description / secondary copy — ~15–20% smaller. */
export const PDF_DESC_CLASS = "text-[10px] leading-[1.4] text-[#4B5563]";

/** Section eyebrow labels. */
export const PDF_EYEBROW_CLASS = "text-[9px] font-semibold uppercase tracking-[0.16em] text-[#C8A96A]";

/** Section headings with gold rule. */
export const PDF_SECTION_TITLE_CLASS =
  "text-[13px] font-semibold uppercase tracking-[0.1em] text-[#1A2744] border-b-2 border-[#C8A96A] pb-1.5";
